/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type VimeoVideoStatus = "available" | "generic_error" | "not_found" | "not_found_error" | "quota_exceeded" | "transcode_starting" | "transcoding" | "transcoding_error" | "uploading" | "uploading_error" | "%future added value";
export type PdpRespHeroCarousel_item = {
    readonly defaultSkuId: string | null;
    readonly isMultiSku: boolean;
    readonly hasPrivateListing: boolean | null;
    readonly photos: ReadonlyArray<{
        readonly largePath: string | null;
        readonly masterOrZoomPath: string | null;
        readonly alt: string | null;
    } | null> | null;
    readonly viewInRoomPhotos: ReadonlyArray<{
        readonly src: string | null;
        readonly credits: string | null;
        readonly srcSetProps: {
            readonly sizes: string | null;
            readonly srcSet: string | null;
        } | null;
        readonly centerPosition: {
            readonly top: string | null;
            readonly left: string | null;
        } | null;
        readonly comparatorWidth: {
            readonly pixel: string | null;
            readonly inches: string | null;
        } | null;
    } | null> | null;
    readonly measurement: {
        readonly convertedMeasurements: {
            readonly width: string | null;
            readonly height: string | null;
        } | null;
        readonly hoverDimensionsWidth: ReadonlyArray<{
            readonly unit: string | null;
            readonly value: string | null;
        } | null> | null;
        readonly hoverDimensionsHeight: ReadonlyArray<{
            readonly unit: string | null;
            readonly value: string | null;
        } | null> | null;
    } | null;
    readonly videoVimeo: {
        readonly thumbnail: string | null;
        readonly status: VimeoVideoStatus | null;
        readonly vimeoId: string | null;
    } | null;
    readonly reviews: {
        readonly videoReview: {
            readonly status: string | null;
        } | null;
    } | null;
    readonly sortedPhotos: ReadonlyArray<{
        readonly serviceId: string | null;
        readonly largePath: string | null;
        readonly masterOrZoomPath: string | null;
        readonly alt: string | null;
        readonly sortOrder: number | null;
        readonly imageSkuXrefs: ReadonlyArray<{
            readonly skuId: string | null;
        } | null> | null;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespHeroCarouselRequestMoreImages_item" | "PdpRespIconBubblesWrapper_item">;
    readonly " $refType": "PdpRespHeroCarousel_item";
};
export type PdpRespHeroCarousel_item$data = PdpRespHeroCarousel_item;
export type PdpRespHeroCarousel_item$key = {
    readonly " $data"?: PdpRespHeroCarousel_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespHeroCarousel_item">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "largePath",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "masterOrZoomPath",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "alt",
  "storageKey": null
},
v3 = {
  "kind": "Literal",
  "name": "addLabel",
  "value": false
},
v4 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "unit",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespHeroCarousel_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "defaultSkuId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isMultiSku",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasPrivateListing",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemPhoto",
      "kind": "LinkedField",
      "name": "photos",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "viewInRoomPhotos",
      "kind": "LinkedField",
      "name": "viewInRoomPhotos",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "src",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "credits",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "viewInRoomPhotosSrcSet",
          "kind": "LinkedField",
          "name": "srcSetProps",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sizes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "srcSet",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "viewInRoomPhotosCenterPosition",
          "kind": "LinkedField",
          "name": "centerPosition",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "top",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "left",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "viewInRoomPhotosComparatorWidth",
          "kind": "LinkedField",
          "name": "comparatorWidth",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "pixel",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "inches",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemMeasurement",
      "kind": "LinkedField",
      "name": "measurement",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "unit",
              "value": "IN"
            }
          ],
          "concreteType": "ItemConvertedMeasurementsType",
          "kind": "LinkedField",
          "name": "convertedMeasurements",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "width",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "height",
              "storageKey": null
            }
          ],
          "storageKey": "convertedMeasurements(unit:\"IN\")"
        },
        {
          "alias": "hoverDimensionsWidth",
          "args": [
            (v3/*: any*/),
            {
              "kind": "Literal",
              "name": "fields",
              "value": [
                "width"
              ]
            }
          ],
          "concreteType": "ItemDisplayMeasurementType",
          "kind": "LinkedField",
          "name": "display",
          "plural": true,
          "selections": (v4/*: any*/),
          "storageKey": "display(addLabel:false,fields:[\"width\"])"
        },
        {
          "alias": "hoverDimensionsHeight",
          "args": [
            (v3/*: any*/),
            {
              "kind": "Literal",
              "name": "fields",
              "value": [
                "height"
              ]
            }
          ],
          "concreteType": "ItemDisplayMeasurementType",
          "kind": "LinkedField",
          "name": "display",
          "plural": true,
          "selections": (v4/*: any*/),
          "storageKey": "display(addLabel:false,fields:[\"height\"])"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "VideoVimeo",
      "kind": "LinkedField",
      "name": "videoVimeo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "includePlayButton",
              "value": false
            },
            {
              "kind": "Literal",
              "name": "pad",
              "value": false
            },
            {
              "kind": "Literal",
              "name": "size",
              "value": "w100h75"
            }
          ],
          "kind": "ScalarField",
          "name": "thumbnail",
          "storageKey": "thumbnail(includePlayButton:false,pad:false,size:\"w100h75\")"
        },
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "vimeoId",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemReviewDocumentList",
      "kind": "LinkedField",
      "name": "reviews",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ItemReview",
          "kind": "LinkedField",
          "name": "videoReview",
          "plural": false,
          "selections": [
            (v5/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemPhoto",
      "kind": "LinkedField",
      "name": "sortedPhotos",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceId",
          "storageKey": null
        },
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sortOrder",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ImageSkuXref",
          "kind": "LinkedField",
          "name": "imageSkuXrefs",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "skuId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespHeroCarouselRequestMoreImages_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubblesWrapper_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();
(node as any).hash = '5c87748c04c396cd17665a4a3832ad45';
export default node;
